<slick-container *ngIf="businessDevelopmentAccount" maxHeight="calc(100vh - 80px)">
    <slick-container-header>
        <div class="d-flex flex-fill w-100 mt-3 mb-2 border-bottom">
            <div class="d-flex flex-fill">
                <h4 class="p-0 m-0">{{businessDevelopmentAccount.contact.displayName}}</h4>
            </div>

            <div *ngIf="canUpdateAccounts">
                <button type="button" class="btn btn-link" (click)="editAccount()"><i class="far fa-pencil"></i>&nbsp;Edit Account</button>
            </div>
        </div>
    </slick-container-header>

    <slick-container-body>
        <slick-tabs>
            <slick-tab header="Account">
                <div class="d-flex flex-column w-100">
                <div class="d-flex flex-row flex-nowrap ms-3" style="width: 100%;">
                    <div class="d-flex flex-column pt-3 pe-3" [style.min-height]="canViewNotes ? 'calc(100vh - 540px)' : 'calc(100vh - 220px)'" [style.max-height]="canViewNotes ? 'calc(100vh - 540px)' : 'calc(100vh - 220px)'" style="min-width: 260px; width: 260px; flex-shrink: 0; overflow-y:auto">
                        <div>
                            <contact-display [contactModel]="businessDevelopmentAccount.contact"></contact-display>
                        </div>

                        <div class="mb-2">
                            <label>Scratchpad</label>
                            <textarea class="form-control"
                                      rows="2"
                                      [disabled]="!canUpdateAccounts"
                                      [(ngModel)]="businessDevelopmentAccount.scratchpad"
                                      (change)="updateAccount()"></textarea>
                        </div>

                        <div class="mb-2">
                            <div class="d-flex">
                                <div class="flex-fill me-1">
                                    <label>Account Type</label>
                                    <slick-drop-down [items]="accountTypes"
                                                     [disabled]="!canUpdateAccounts"
                                                     [ngModel]="businessDevelopmentAccount.businessDevelopmentAccountTypeId"
                                                     (onSelect)="onAccountTypeChanged($event)"></slick-drop-down>
                                </div>

                                <div *ngIf="canUpdateAccounts" class="d-flex align-items-end">
                                    <button class="btn btn-primary" (click)="editAccountTypes()"><i class="far fa-pencil text-primary"></i></button>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="businessDevelopmentAccount.businessDevelopmentAccountTypeDescription === 'Agent' || businessDevelopmentAccount.businessDevelopmentAccountTypeDescription === 'Insurance Adjuster'" class="mb-2">
                            <label>Carrier</label>
                            <slick-drop-down [items]="carriers"
                                             [disabled]="!canUpdateAccounts"
                                             [ngModel]="businessDevelopmentAccount.carrierId"
                                             (onSelect)="onCarrierChanged($event)"></slick-drop-down>
                        </div>

                        <div class="mb-1">
                            <label>Marketing Rep</label>
                            <slick-drop-down [items]="marketingEmployees"
                                             [disabled]="!canUpdateAccounts"
                                             [ngModel]="businessDevelopmentAccount.marketingEmployeeId"
                                             (onSelect)="onMarketingEmployeeChanged($event)"
                                             placeholder="None"></slick-drop-down>
                        </div>
                        <div>
                            <input type="checkbox" [disabled]="canSetCommissionEligible === false" [checked]="businessDevelopmentAccount.isCommissionEligible" (change)="onIsCommissionEligibleChanged()" />Commission Eligible
                        </div>

                        <div *ngIf="businessDevelopmentAccount.isCommissionEligible" class="d-flex align-items-center">
                            <div class="input-group ms-3 me-1" style="width: 100px">
                                <input type="tel" [disabled]="canSetCommissionEligible === false" class="form-control" style="text-align: center" [(ngModel)]="businessDevelopmentAccount.defaultCommissionPercent" (blur)="updateAccount()" />
                                <span class="input-group-text">%</span>
                            </div>
                            <div>
                                Commission
                            </div>
                        </div>
                        <br />
                        <button *ngIf="canAddNotes" type="button" class="btn btn-outline-primary" (click)="onRecordVisitClick()">
                            <i class="far fa-handshake"></i>&nbsp;Record Visit
                        </button>
                        <br />

                        <div class="mb-2 mt-2">
                            <label>Default Email</label>
                            <input type="email" class="form-control" [disabled]="!canUpdateAccounts" [(ngModel)]="businessDevelopmentAccount.defaultEmail" (change)="updateAccount()" />
                        </div>

                        <div style="line-height: 1.2rem">
                            <input type="checkbox" [disabled]="!canUpdateAccounts" [checked]="businessDevelopmentAccount.isReferral" (change)="onIsReferralChanged()" />Referral<br />
                            <input type="checkbox" [disabled]="!canUpdateAccounts" [checked]="businessDevelopmentAccount.isCarrier" (change)="onIsCarrierChanged()" />Carrier<br />
                        </div>

                        <div class="mt-2">
                            <label>Visit Frequency Days</label>
                            <input type="number" step="1" class="form-control"
                                   [disabled]="!canUpdateAccounts"
                                   [(ngModel)]="businessDevelopmentAccount.visitFrequency"
                                   (change)="updateAccount()" />
                        </div>

                        <div class="mt-1">
                            <label>Days Before Warning</label>
                            <input type="number" step="1" class="form-control"
                                   [disabled]="!canUpdateAccounts"
                                   [(ngModel)]="businessDevelopmentAccount.daysBeforeWarning"
                                   (change)="updateAccount()" />
                        </div>

                        <div class="mt-1">
                            <label>Last Visit Date</label>
                            <input *ngIf="canUpdateAccounts" type="text" class="form-control"
                                   [slick-date-picker]
                                   [(ngModel)]="businessDevelopmentAccount.lastVisitDate"
                                   (onDateChange)="updateAccount()" />
                            <input *ngIf="!canUpdateAccounts" type="text" class="form-control" disabled [value]="businessDevelopmentAccount.lastVisitDate | date:'M/d/yyyy'" />
                        </div>
                    </div>

                    <div *ngIf="canViewJobs" class="d-flex flex-column flex-fill ms-3 ps-3 pt-2 border-left" style="min-width: 0;">
                        <div [style.min-height]="canViewNotes ? 'calc(100vh - 545px)' : 'calc(100vh - 225px)'" [style.max-height]="canViewNotes ? 'calc(100vh - 545px)' : 'calc(100vh - 225px)'" style="overflow-y: auto;">
                            <h5 class="border-0">Jobs</h5>
                            <div *ngIf="!jobs">Loading&nbsp;<div class="waiting-gif"></div></div>
                            <div *ngIf="jobs && jobs.length === 0">No jobs</div>
                            <div *ngIf="jobs && jobs.length > 0" class="d-flex flex-column">
                                <div *ngFor="let job of jobs" class="mb-2 pb-2 ps-2 border-bottom" style="font-size: .8rem; line-height: 1rem">
                                    <h5 class="border-0 p-0 m-0"><a [href]="'/#/jobs/' + job.uuid" target="_blank" rel="noopener" class="text-primary">{{job.jobName}}</a></h5>
                                    {{job.fullName}}<br />
                                    {{job.primaryAddress1}}<br />
                                    {{job.primaryCityStatePostal}}<br />
                                    <div class="mt-1"></div>
                                    Open Date: {{job.openDate | date:'M/d/yyyy'}}<br />
                                    Job Status: {{job.jobStatusDescription}}<br />
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
                <div *ngIf="canViewNotes" style="height: 320px; min-height: 32px; flex-shrink: 0;" class="mt-3">
                    <business-development-notes #businessDevelopmentNotesRef
                                                [businessDevelopmentAccountId]="businessDevelopmentAccount.businessDevelopmentAccountId"
                                                [businessDevelopmentAccount]="businessDevelopmentAccount"
                                                (onNoteAdded)="onNoteAdded()"></business-development-notes>
                </div>
                </div>
            </slick-tab>

            <slick-tab header="Contacts">
                <div class="d-flex flex-column mx-3 pt-3">
                    <div *ngIf="canUpdateAccounts" class="mb-2">
                        <button class="btn btn-link" (click)="addNewContact()"><i class="far fa-plus"></i> New Contact</button>
                    </div>

                    <div *ngIf="businessDevelopmentAccount.businessDevelopmentContacts.length === 0">No Contacts</div>
                    <div *ngIf="businessDevelopmentAccount.businessDevelopmentContacts.length > 0" class="d-flex flex-column flex-fill">
                        <div *ngFor="let businessDevelopmentContact of businessDevelopmentAccount.businessDevelopmentContacts" class="mb-2 pt-2 border-top d-flex flex-column w-100">
                            <div class="d-flex flex-fill">
                                <div class="flex-fill" style="line-height: 1rem; font-size: .8rem">
                                    <h5 class="border-0">{{businessDevelopmentContact.contact.fullName}}</h5>
                                    <span *ngIf="businessDevelopmentContact.businessDevelopmentContactRoleName">{{businessDevelopmentContact.businessDevelopmentContactRoleName}}<br /></span>
                                    <span *ngIf="businessDevelopmentContact.contact.defaultAddress?.address1">{{businessDevelopmentContact.contact?.defaultAddress?.address1}}<br /></span>
                                    <span *ngIf="businessDevelopmentContact.contact.defaultAddress?.address2">{{businessDevelopmentContact.contact.defaultAddress?.address2}}<br /></span>
                                    <div *ngIf="businessDevelopmentContact.contact.defaultAddress?.cityStatePostal">{{businessDevelopmentContact.contact.defaultAddress?.cityStatePostal}}</div>
                                    <div style="margin-bottom: 5px;"></div>
                                    <span *ngIf="businessDevelopmentContact.contact.defaultCell && businessDevelopmentContact.contact.defaultCell.phoneNumber">Cell: {{businessDevelopmentContact.contact.defaultCell.phoneNumber}}<br /></span>
                                    <span *ngIf="businessDevelopmentContact.contact.defaultAlt1 && businessDevelopmentContact.contact.defaultAlt1.phoneNumber">Alt 1: {{businessDevelopmentContact.contact.defaultAlt1.phoneNumber}}<br /></span>
                                    <span *ngIf="businessDevelopmentContact.contact.defaultAlt2 && businessDevelopmentContact.contact.defaultAlt2.phoneNumber">Alt 2: {{businessDevelopmentContact.contact.defaultAlt2.phoneNumber}}<br /></span>
                                </div>
                                <div style="min-width: 100px;">
                                    <button *ngIf="canUpdateAccounts" class="btn btn-outline-primary btn-sm me-1" title="Edit Contact" (click)="editContact(businessDevelopmentContact)"><i class="far fa-pencil text-primary"></i></button>
                                    <button *ngIf="canDeleteAccounts" class="btn btn-danger btn-sm me-1" title="Delete Contact" (click)="deleteContact(businessDevelopmentContact)"><i class="far fa-trash"></i></button>
                                </div>
                            </div>
                            <div *ngIf="businessDevelopmentContact.note" class="bg-info text-white p-1 border" style="font-size: .8rem; line-height: .8rem;">{{businessDevelopmentContact.note}}</div>
                            <div *ngIf="!businessDevelopmentContactsChecklistGroups()">Loading&nbsp;<div class="waiting-gif"></div></div>
                            <div *ngIf="businessDevelopmentContactsChecklistGroups()">
                                <checklist-display [checklistGroups]="getContactChecklists(businessDevelopmentContact?.businessDevelopmentContactId)"></checklist-display>
                                <button *ngIf="canUpdateAccounts" type="button" class="btn btn-link m-0" (click)="editContactChecklist(businessDevelopmentContact?.businessDevelopmentContactId)"><i class="far fa-pencil"></i> Edit Profile</button>
                            </div>
                        </div>

                        <div class="border-bottom"></div>
                    </div>
                </div>
            </slick-tab>

            <slick-tab header="Checklists">
                <div *ngIf="!businessDevelopmentAccountChecklistGroups()" class="pt-3">
                    Loading&nbsp;<div class="waiting-gif"></div>
                </div>
                <div *ngIf="businessDevelopmentAccountChecklistGroups()" style="max-width: 420px" class="pt-3" [style.pointer-events]="canUpdateAccounts ? 'auto' : 'none'">
                    <checklists [checklistGroups]="businessDevelopmentAccountChecklistGroups()" (onChecklistItemChanged)="checklistItemChanged($event)"></checklists>
                </div>

            </slick-tab>

            <slick-tab header="Surveys">
                <div *ngIf="surveys && surveys.length === 0" class="p-3">No Surveys</div>
                <div *ngIf="surveys && surveys.length > 0" class="p-3 d-flex flex-column">
                    <div *ngFor="let survey of surveys" class="card mb-2">
                        <div class="card-header d-flex">
                            <div class="flex-fill align-self-center">{{survey.jobName}}</div>
                            <div>
                                <button class="btn btn-sm btn-primary" (click)="emailSurvey(survey.surveyId)"><i class="far fa-envelope"></i></button>
                            </div>

                        </div>
                        <div class="card-body">
                            <div *ngFor="let surveyQuestionAndAnswer of survey.surveyQuestionsWithAnswers" class="d-flex flex-column">
                                <div>{{surveyQuestionAndAnswer.surveyQuestion}}</div>
                                <slick-star-rating [(ngModel)]="surveyQuestionAndAnswer.surveyAnswer" readonly="true"></slick-star-rating>
                            </div>

                            <div>
                                <label>Notes:</label>
                                <pre class="border p-2">{{survey.customNotes}}</pre>
                            </div>

                            <div *ngIf="survey.additionalNotes">
                                <label>Additional Notes:</label>
                                <pre class="border p-2">{{survey.additionalNotes}}</pre>
                            </div>
                        </div>
                    </div>
                </div>
            </slick-tab>

            <slick-tab header="ROI">
                <div class="p-3">
                    <div class="d-flex flex-column">
                        <div class="mb-2">
                            <slick-multi-select-pills [items]="roiCalcTypes"
                                                      [ngModel]="selectedROICalcTypes"
                                                      (onItemChanged)="onROICalcTypeChanged($event)"></slick-multi-select-pills>
                        </div>

                        <table class="table table-sm table-no-padding table-borderless" style="width: 600px; table-layout: fixed">
                            <colgroup>
                                <col style="width: 250px" />
                                <col />
                                <col style="width: 40px" />
                                <col />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <td><h5 class="mx-1 border-0">Total marketing spend</h5></td>
                                    <td><h5 class="mx-1 border-0">{{roiExpensesTotal | currency}}</h5></td>
                                </tr>
                                <tr>
                                    <td><h5 class="mx-1 border-0">Total WON {{roiCalcDescription}} (Open)</h5></td>
                                    <td><h5 class="mx-1 border-0">{{roiCalcOpenTotal | currency:'USD':'symbol':'0.0-0'}}</h5></td>
                                    <td><h5 class="mx-1 border-0">ROI</h5></td>
                                    <td><h5 class="mx-1 border-0">{{roiCalcOpenPercent | percent}}</h5></td>
                                </tr>
                                <tr>
                                    <td><h5 class="mx-1 border-0">Total WON {{roiCalcDescription}} (Closed)</h5></td>
                                    <td><h5 class="mx-1 border-0">{{roiCalcClosedTotal | currency:'USD':'symbol':'0.0-0'}}</h5></td>
                                    <td><h5 class="mx-1 border-0">ROI</h5></td>
                                    <td><h5 class="mx-1 border-0">{{roiCalcClosedPercent | percent}}</h5></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <table class="js-table">
                        <thead>
                            <tr>
                                <th>Employee</th>
                                <th>Vendor</th>
                                <th>Expense Type</th>
                                <th>Expense Date</th>
                                <th>Amount</th>
                                <th>Note</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr *ngFor="let roiExpense of roiExpenses">
                                <td>{{roiExpense.employeeFullName}}</td>
                                <td>{{roiExpense.payableVendorDisplayName}}</td>
                                <td>{{roiExpense.expenseType}}</td>
                                <td>{{roiExpense.expenseDate | date:'M/d/yyyy'}}</td>
                                <td>{{roiExpense.expenseAmount | currency}}</td>
                                <td>{{roiExpense.note}}</td>
                            </tr>
                        </tbody>

                        <tfoot>
                            <tr>
                                <td colspan="4" style="text-align: right"><h5 class="border-0">Total Spend</h5></td>
                                <td colspan="2"><h5 class="border-0">{{roiExpensesTotal | currency}}</h5></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </slick-tab>

        </slick-tabs>
    </slick-container-body>
</slick-container>

<business-development-account-edit-dialog #businessDevelopmentAccountEditDialog></business-development-account-edit-dialog>
<business-development-account-types-dialog #businessDevelopmentAccountTypesDialog></business-development-account-types-dialog>
<business-development-contact-edit-dialog #businessDevelopmentContactEditDialog></business-development-contact-edit-dialog>

<emailer-dialog #emailerDialogRef></emailer-dialog>

<slick-dialog #recordVisitDialog
              [width]="380"
              [showHeader]="true" header="Record Visit">

    <div class="mb-1 me-1">
        <label>Visit Date/Time</label>
        <date-time-entry [(date)]="visitDate" (isValid)="isValidVisitDate = $event"></date-time-entry>
    </div>

    <!-- Note area -->
    <div>
        <label>Visit Notes</label>
        <textarea class="form-control"
                  rows="4"
                  [(ngModel)]="visitNote">
            </textarea>
    </div>

    <slick-dialog-footer>
        <button type="button" [slick-button-spinner]="visitSpinnerStatus" class="btn btn-outline-primary save-button" (click)="onSaveVisit()"><i class="far fa-save"></i>&nbsp;Save</button>
        <button type="button" class="btn btn-outline-danger cancel-button" (click)="onCancelVisit()"><i class="far fa-ban"></i>&nbsp;Cancel</button>
    </slick-dialog-footer>

</slick-dialog>

﻿
﻿<slick-dialog #contactChecklistDialogRef header="Contact Checklist" [width]='600' top='50' [resizable]="false">
    <checklists [checklistGroups]="contactChecklistGroups()"></checklists>

    <slick-dialog-footer>

        <button type="button" (click)="onSaveContactChecklist()" [slick-button-spinner]="spinnerStatus1" class="btn btn-outline-primary save-button"><i class="far fa-save"></i>&nbsp;Save</button>
        <button type="button" class="btn btn-outline-danger cancel-button" (click)="onCancelContactChecklist()"><i class="far fa-ban"></i>&nbsp;Cancel</button>

    </slick-dialog-footer>
</slick-dialog>

